@if (isLoading()) {
	<div class="dsd-loading">
		<mat-spinner diameter="40"></mat-spinner>
	</div>
} @else if (rows().length === 0) {
	<div class="dsd-empty">
		<mat-icon><i class="fa-solid fa-file-circle-xmark" aria-hidden="true"></i></mat-icon>
		<p>Brak zeskanowanych dokumentów dla tego kierowcy.</p>
	</div>
} @else {
	<ul class="dsd-list">
		@for (row of rows(); track row.id) {
			<li class="dsd-item" [class.dsd-item--open]="expandedId() === row.id">
				<button
					type="button"
					class="dsd-head"
					[attr.aria-expanded]="expandedId() === row.id"
					(click)="toggleExpand(row)"
				>
					<i
						class="fas dsd-chevron"
						[class.fa-chevron-down]="expandedId() !== row.id"
						[class.fa-chevron-up]="expandedId() === row.id"
						aria-hidden="true"
					></i>
					<span class="dsd-date">{{ row.timeStamp | date: 'yyyy-MM-dd HH:mm' }}</span>
					@if (row.idBox !== null) {
						<span class="dsd-box">box {{ row.idBox }}</span>
					}
					@if (row.answers | firstScanRef; as scan) {
						<app-scan-status-badges
							class="dsd-status"
							[ocrStatus]="scan.ocrStatus"
							[costStatus]="scan.costStatus"
							[archiveStatus]="scan.archiveStatus"
							[showOcr]="false"
							[showArchive]="false"
						/>
					}
				</button>
				@if (expandedId() === row.id) {
					<div class="dsd-body">
						<app-report-answers-table
							[answers]="row.answers"
							[driverId]="driverId()"
							(scanUpdated)="applyScanUpdate($event)"
						/>
					</div>
				}
			</li>
		}
	</ul>

	@if (total() > pageSize()) {
		<mat-paginator
			[length]="total()"
			[pageIndex]="pageIndex()"
			[pageSize]="pageSize()"
			[pageSizeOptions]="pageSizeOptions"
			(page)="onPage($event)"
		></mat-paginator>
	}
}
